import { useEffect } from 'react';
import SignUp from 'src/app/auth/sign-up';
import { COOKIES_AUTH_TOKEN } from 'src/constants/cookies';
import { destroyCookie, getCookie } from 'src/lib/cookies';

function SignUpPage() {
  useEffect(() => {
    const token = getCookie(COOKIES_AUTH_TOKEN);
    if (token) {
      destroyCookie(COOKIES_AUTH_TOKEN);
    }
  }, []);

  return <SignUp />;
}

export default SignUpPage;
